<template>
    <ContentModal v-model="show" :title="isComplete ? '✅ Setup Complete' : '⚠️ Setup Pending'" size="md">
        <div class="setup-status-modal">
            <!-- Header banner -->
            <div class="ssm-banner" :class="isComplete ? 'ssm-banner-complete' : 'ssm-banner-pending'">
                <i class="material-icons ssm-banner-icon">{{ isComplete ? 'verified' : 'pending_actions' }}</i>
                <div>
                    <h6 class="ssm-banner-title">{{ isComplete ? 'All setup steps are complete!' : 'Some setup steps are still pending' }}</h6>
                    <p class="ssm-banner-sub" v-if="percent != null">{{ percent }}% complete ({{ completedCount }} of {{ totalCount }} items)</p>
                </div>
            </div>

            <!-- Pending items -->
            <div v-if="items && items.length > 0" class="ssm-section">
                <h6 class="ssm-section-title"><i class="material-icons">assignment_late</i> Items that need attention</h6>
                <div v-for="(item, idx) in items" :key="idx" class="ssm-item ssm-item-pending">
                    <i class="material-icons ssm-item-icon">radio_button_unchecked</i>
                    <span>{{ item }}</span>
                </div>
            </div>

            <div v-if="isComplete" class="ssm-section">
                <div class="ssm-item ssm-item-done">
                    <i class="material-icons ssm-item-icon">task_alt</i>
                    <span>All required configuration is in place. The scheduling engine can operate on this {{ entityLabel }}.</span>
                </div>
            </div>
        </div>
    </ContentModal>
</template>

<script setup>
import ContentModal from './ContentModal.vue'

import { computed } from 'vue'

const props = defineProps({
    modelValue: { type: Boolean, default: false },
    setupStatus: { type: Object, default: null },
    entityLabel: { type: String, default: 'activity' },
})

const emit = defineEmits(['update:modelValue'])

const show = computed({
    get: () => props.modelValue,
    set: (v) => emit('update:modelValue', v),
})

const isComplete = computed(() => props.setupStatus?.setupcomplete ?? false)
const items = computed(() => props.setupStatus?.setupitemsarray ?? [])
const percent = computed(() => props.setupStatus?.setuppercent ?? null)
const completedCount = computed(() => props.setupStatus?.completed_items ?? 0)
const totalCount = computed(() => props.setupStatus?.total_items ?? 0)
</script>

<style scoped>
.setup-status-modal { padding: 4px 0; }
.ssm-banner {
    display: flex;
    align-items: center;
    gap: 14px;
    padding: 16px 20px;
    border-radius: 12px;
    margin-bottom: 20px;
}
.ssm-banner-complete {
    background: linear-gradient(135deg, #e8f5e9, #c8e6c9);
    border: 1px solid #a5d6a7;
}
.ssm-banner-pending {
    background: linear-gradient(135deg, #fff8e1, #ffecb3);
    border: 1px solid #ffe082;
}
.ssm-banner-icon { font-size: 36px; }
.ssm-banner-complete .ssm-banner-icon { color: #2e7d32; }
.ssm-banner-pending .ssm-banner-icon { color: #f57f17; }
.ssm-banner-title {
    margin: 0;
    font-size: 0.95rem;
    font-weight: 700;
    color: #344767;
}
.ssm-banner-sub {
    margin: 2px 0 0;
    font-size: 0.8rem;
    color: #7b809a;
}
.ssm-section { margin-bottom: 16px; }
.ssm-section-title {
    display: flex;
    align-items: center;
    gap: 6px;
    font-size: 0.85rem;
    font-weight: 700;
    color: #344767;
    margin-bottom: 10px;
}
.ssm-section-title i { font-size: 18px; color: #f57f17; }
.ssm-item {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 10px 14px;
    border-radius: 8px;
    margin-bottom: 6px;
    font-size: 0.85rem;
}
.ssm-item-pending {
    background: #fff3e0;
    color: #e65100;
}
.ssm-item-done {
    background: #e8f5e9;
    color: #2e7d32;
}
.ssm-item-icon { font-size: 18px; margin-top: 1px; flex-shrink: 0; }
</style>
